import { jsx as _jsx } from "react/jsx-runtime";
import ModalAntd from 'antd/es/modal';
import styled, { useTheme } from 'styled-components';
import { useFullModalHeight } from './use-full-modal-height';
/**
 * 无任何内容的全屏弹窗，具体样式需自行实现
 *
 * @param props - props
 * @param props.visible - 是否显示
 * @param props.style - 样式
 * @param props.className - class name
 * @param props.zIndex - z-index
 * @returns component
 */
export const PlainFullScreen = ({ children, visible, style, className, zIndex }) => {
    const theme = useTheme();
    const height = useFullModalHeight(true);
    return (_jsx(Wrapper, Object.assign({ open: visible, title: "", closable: false, footer: null, bodyStyle: {
            padding: 0,
            height,
            backgroundColor: theme.background._3,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
        }, style: style, className: className, zIndex: zIndex }, { children: children }), void 0));
};
const Wrapper = styled(ModalAntd) `
  &&& {
    top: 0;
    width: 100% !important;
    height: 100%;
    margin: 0;

    .ant-modal-content {
      border-radius: 0;
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGxhaW5GdWxsU2NyZWVuLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL01vZGFsL1BsYWluRnVsbFNjcmVlbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sU0FBUyxNQUFNLGVBQWUsQ0FBQTtBQUVyQyxPQUFPLE1BQU0sRUFBRSxFQUFFLFFBQVEsRUFBRSxNQUFNLG1CQUFtQixDQUFBO0FBRXBELE9BQU8sRUFBRSxrQkFBa0IsRUFBRSxNQUFNLHlCQUF5QixDQUFBO0FBRTVEOzs7Ozs7Ozs7R0FTRztBQUNILE1BQU0sQ0FBQyxNQUFNLGVBQWUsR0FLdkIsQ0FBQyxFQUFFLFFBQVEsRUFBRSxPQUFPLEVBQUUsS0FBSyxFQUFFLFNBQVMsRUFBRSxNQUFNLEVBQUUsRUFBRSxFQUFFO0lBQ3ZELE1BQU0sS0FBSyxHQUFHLFFBQVEsRUFBRSxDQUFBO0lBRXhCLE1BQU0sTUFBTSxHQUFHLGtCQUFrQixDQUFDLElBQUksQ0FBQyxDQUFBO0lBRXZDLE9BQU8sQ0FDTCxLQUFDLE9BQU8sa0JBQ04sSUFBSSxFQUFFLE9BQU8sRUFDYixLQUFLLEVBQUMsRUFBRSxFQUNSLFFBQVEsRUFBRSxLQUFLLEVBQ2YsTUFBTSxFQUFFLElBQUksRUFDWixTQUFTLEVBQUU7WUFDVCxPQUFPLEVBQUUsQ0FBQztZQUNWLE1BQU07WUFDTixlQUFlLEVBQUUsS0FBSyxDQUFDLFVBQVUsQ0FBQyxFQUFFO1lBQ3BDLE9BQU8sRUFBRSxNQUFNO1lBQ2YsYUFBYSxFQUFFLFFBQVE7WUFDdkIsUUFBUSxFQUFFLFFBQVE7U0FDbkIsRUFDRCxLQUFLLEVBQUUsS0FBSyxFQUNaLFNBQVMsRUFBRSxTQUFTLEVBQ3BCLE1BQU0sRUFBRSxNQUFNLGdCQUViLFFBQVEsWUFDRCxDQUNYLENBQUE7QUFDSCxDQUFDLENBQUE7QUFFRCxNQUFNLE9BQU8sR0FBRyxNQUFNLENBQUMsU0FBUyxDQUFDLENBQUE7Ozs7Ozs7Ozs7O0NBV2hDLENBQUEifQ==